import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { BaseComponent } from '../../../shared/base-components/base.component';

export class TransactionActiveData {
    constructor(public businessTransactionUnitName: string) {}
}

@Component({
    selector: 'transaction-active-modal',
    templateUrl: './transaction-active-modal.html'
})

export class TransactionActiveWindow extends BaseComponent {

    constructor(public dialogRef: MatDialogRef<TransactionActiveWindow>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: TransactionActiveData) {
        super();
    }

    ngOnInit() {}

    public accept() {
        this.dialogRef.close(true);
    }

    public cancel() {
        this.dialogRef.close();
    }
}
